module.exports = __webpack_public_path__ + "img/icon_touxiang_three@3x.86f92797.png";